module.exports = __webpack_public_path__ + "img/poster.4b2226d5.png";